var parent = require('../../es/object/get-own-property-symbols');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/get-own-property-symbols.js
// module id = 1019
// module chunks = 0